import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { loadEnterpriseAssociationsStart } from 'services/redux/actions/serviceDesk';
import conxtdOut from 'apis/conxtdOut';
import Alert from 'components/Common/Alert';

export function useEnterpriseAssociationsHandler() {
  const dispatch = useDispatch();
  let finalData = {};

  /**
   * Handler function that runs the alert & submission logic for - Enterprise Associations
   */
  const handleEnterpriseAssociations = useCallback(async ({
    sudoSiteId,
    editData,
    addToEnterpriseData,
    setLoadingSubmitEdit,
    setInitialiseFormDataTrigger,
    setInvalidEnterprise,
    siteDetails,
    editSubmissionType,
  }) => {
    const result = await Alert({
      title: 'Are you sure you want to save these changes?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    });

    if (!result.value) return;

      const enterpriseIds = [];

    // defines data structure for submission
    if (editSubmissionType) {
      const dataArray = [];
      
      for (const value of editData.values()) {
        enterpriseIds.push(value.enterprise)
        dataArray.push(value)
      }
      
      if (dataArray.length > 0) {
        finalData = Object.values(dataArray);
      }

    } else {
      enterpriseIds.push(addToEnterpriseData?.enterprise)
      finalData = {
        ...addToEnterpriseData,
        timezone: siteDetails?.timezone,
        address1: siteDetails?.address1,
      };
    }

    if (!sudoSiteId || !editData) return;

    try {
      setLoadingSubmitEdit(true);

      if (editSubmissionType) {
        await conxtdOut.post(`/ServiceDesk/editEnterpriseAssociations/${sudoSiteId}`, finalData);
      } else {
        await conxtdOut.post(`/ServiceDesk/addEnterpriseSite/${sudoSiteId}`, finalData);
      }

      setLoadingSubmitEdit(false);
      Alert({
        text: `${editSubmissionType ? `Changes saved successfully` : 'Enterprise association added successfully'}`,
        icon: 'success',
        timerProgressBar: true,
        timer: 5000,
      });

      dispatch(loadEnterpriseAssociationsStart({ sudoSiteId }));

      setInitialiseFormDataTrigger(true);
      setInvalidEnterprise(true);      

      if (enterpriseIds.length > 0) {
        for (const id of enterpriseIds) {
          window.caching.flush(`LOAD_GROUPS_BACKGROUND_SUCCESS/${id}`);
          window.caching.flush(`LOAD_SITES_BACKGROUND_SUCCESS/${id}`);
        }
      }
    } catch (error) {
      console.error(error);
      setLoadingSubmitEdit(false);
      Alert({
        text: 'An issue occurred. Please try again later.',
        icon: 'error',
      });
    }
  }, [dispatch]);

  return { handleEnterpriseAssociations };
}
